import axios from "axios";


//获取正在沟通的专家
export const getTeacherDialoging = (data) => {
    return axios.request({
        method: "get",
        url: "/askApi/record/getLastDialogUserId",
        //data: data,
        headers: { 'content-Type': 'application/json' },
    });
};

//获取专家列表
export const getTeacherData = (data) => {
    return axios.request({
        method: "POST",
        url: "/askApi/advisory/list",
        data: data,
        headers: { 'content-Type': 'application/json' },
    });
};

//获取和专家的聊天记录
export const getMessageData = (data) => {
    return axios.request({
        method: "POST",
        url: "/askApi/record/getUserMessageList",
        data: data,
        headers: { 'content-Type': 'application/json' },
    });
};

//发送消息
export const getSendMSG = (data) => {
    return axios.request({
        method: "POST",
        url: "/askApi//advisory/sendMessage",
        data: data,
        headers: { 'content-Type': 'application/json' },
    });
} 


//获取秘钥
export function getUserSig(data) {
    return axios({
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
        },
        url:'/askApi/common/getUserSig?customerId='+data.id,
        method: 'get',
    })
}